import jwtDecode from 'jwt-decode'

const storeTokenData = ({ commit, dispatch, getters }, data) => {
  try {
    const res = data
    localStorage.setItem('token', res.data.token)
    localStorage.setItem('refreshToken', res.data.refresh_token)
    let profile = jwtDecode(res.data.token)
    const expirationDate = new Date(profile.exp * 1000)
    localStorage.setItem('expirationDate', expirationDate)
    if (getters.refreshTokenTimer) clearTimeout(getters.refreshTokenTimer)
    const now = new Date()
    const secondsToLogout = expirationDate > 0 ? expirationDate - now : 0
    dispatch('LoginStore/setTokenTimer', secondsToLogout, { root: true })
    commit('LoginStore/authUser', {
      token: res.data.token,
      user: profile
    }, { root: true })
  } catch (e) {
    console.error(e)
  }
}
export {
  storeTokenData
}
